import { render } from "./CreateRecetaElectronica.vue?vue&type=template&id=4a064094&scoped=true"
import script from "./CreateRecetaElectronica.vue?vue&type=script&lang=js"
export * from "./CreateRecetaElectronica.vue?vue&type=script&lang=js"

import "./CreateRecetaElectronica.vue?vue&type=style&index=0&id=4a064094&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a064094"]])

export default __exports__